var LinearExtrude = (function () {
    function LinearExtrude() {
    }
    return LinearExtrude;
}());
export { LinearExtrude };
